import React, { useContext, useEffect, useState } from "react";
import { View, Text, TouchableOpacity } from "react-native";
import { Avatar } from "react-native-elements";
import { useNavigation } from "@react-navigation/native";

import { ButtonAddRoute, TextAddRoute, TextTitlePage } from "./styles";
import {
  Header,
  Container,
  Content,
  TextField,
  Button,
  CustomDropDown,
  ContentButton,
} from "../../../../components";
import RegisterDriverContext from "../../../../context/registerDriver";
import RouteContext from "../../../../context/route";
import UserContext from "../../../../context/user";

function SelectDriverDriver() {
  const navigation = useNavigation();
  const { driversSelects } = useContext(RegisterDriverContext);
  const { setNewRoute } = useContext(RouteContext);
  const { user } = useContext(UserContext);
  const [dateDelivery, setDateDelivery] = useState('');

  async function handleSubmit() {
    const dateSplit = dateDelivery.split('/');
    const newDate = new Date(parseInt(dateSplit[2]), parseInt(dateSplit[1]), parseInt(dateSplit[0]));
    setNewRoute({ driver: user.user_id, isAdmin: false, date: newDate, routes: [] });
    setDateDelivery('');
    navigation.navigate("ListRoutesDriver", '');
  }

  return (
    <Container>
      <Header type="default" />
      <Content>
        <TextTitlePage>Selecione a data de entrega</TextTitlePage>
        <TextField
          label='Data de entrega'
          placeholder='Digite a data de entrega'
          value={dateDelivery}
          mask="date"
          onChangeText={(text: string) => setDateDelivery(text)}
        />
      </Content>
      <ContentButton>
        <Button
          title="Continuar"
          onPress={handleSubmit}
          // disabled={driverValue > 0 ? false : true}
        />
      </ContentButton>
    </Container>
  );
}

export default SelectDriverDriver;
